module.exports = __webpack_public_path__ + "img/93.4d3934f8.svg";